import { fontSizes } from "../../constants/constants";
import { Button, Newlogo, Text } from "../../components/index";
import Functions from "./index.function";
const VerifiedOtp = () => {
  const {
    TextWeight,
    handleSubmit,
    onSubmit,
    otp,
    inputRefs,
    handleChange,
    handleKeyDown,
    handlePaste,
    formatTime,
    timer,
    handleResendOtp,
    resendDisabled,
    loading,
    isOtpComplete,
  } = Functions();

  return (
    <div className="bg-primary scroll-container h-screen">
      <div className="sm:py-5 lg:py-10 max-w-7xl lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center xs:py-5">
          <Newlogo />
        </div>
        <Text
          text={"Forget Password"}
          size={fontSizes.h30}
          weight={TextWeight.Unbounded_bold}
          isCenter={true}
          isTruncate={false}
          className={"sm:py-3"}
          color="text-secondary"
        />
      </div>
      <div className="max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="flex justify-center items-center relative mt-7 sm:w-[60%] xs:w-full lg:w-[50%]">
            <div>
              <Text
                text={"Type Your OTP"}
                size={fontSizes.h14}
                weight={TextWeight.Montserrat_light}
                color="text-secondary mb-5 sm:mb-7 lg:mb-10"
              />
              <div className="flex space-x-3">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    onPaste={handlePaste}
                    className="xs:w-12 xs:h-[50px] sm:w-20 sm:h-20 lg:w-[90px] lg:h-24 text-center border border-goldMetallic bg-[#171717] text-secondary xs:text-lg sm:text-xl lg:text-2xl xs:rounded-lg sm:rounded-xl focus:outline-none focus:ring-1 focus:ring-goldMetallic"
                  />
                ))}
              </div>
              <div className="xs:pt-2 sm:pt-3 flex justify-between items-center">
                <Text
                  text={formatTime(timer)}
                  size={fontSizes.h14}
                  weight={TextWeight.Montserrat_light}
                  color="text-secondary"
                />
                <Text
                  text={"Resend OTP"}
                  size={fontSizes.h14}
                  weight={TextWeight.Montserrat_medium}
                  color="text-goldMetallic hover:underline cursor-pointer"
                  onClick={handleResendOtp}
                  isDisabled={resendDisabled}
                />
              </div>
            </div>
          </div>
          <Button
            text="Submit"
            type={"submit"}
            bgColor="gradient-container_btn"
            color="text-secondary"
            className="w-56 h-10 sm:w-60 sm:h-12 lg:w-64 lg:h-12 mt-5"
            textSize={fontSizes.h16}
            weight={TextWeight.Onest_semiBold}
            loading={loading}
            isDisabled={!isOtpComplete || loading || timer === 0}
          />
        </form>
      </div>
    </div>
  );
};
export default VerifiedOtp;
